import { axiosInstance } from './common';

export const getUserDetails = () => axiosInstance.get(`/user/details`).then((response) => response.data);

export const updateSettings = (settings) => axiosInstance.post(`/user/updateSettings`, settings).then((response) => response.data);


